import * as React from 'react'
import Layout from 'containers/Layout'
import Container from 'theme/atoms/Container'
import Head from './Head'
import { Crumb } from 'theme/atoms/Breadcrumbs'
import styled from 'styled-components'
import Listing from './Listing'
import theme from 'theme'
import withTranslations from './withTranslations'
import Seo from 'theme/atoms/SEO'
import config from 'config'
import { createCrumbsFromCategoryTree } from 'utils/createCrumbs'
import * as dy from 'utils/dy-hybrid'
import { graphql } from 'gatsby'
import { mount } from './events'
import { SeriesContainer } from './types'

type Props = {
  '*': string
  location: {
    pathname: string
    origin: string
  }
  pageContext: {
    slug: string
  }
  data: {
    seriesDetail: SeriesContainer
  }
}

export default withTranslations(function Series(props: Props) {
  const crumbs: Crumb[] = React.useMemo(
    () =>
      props.data.seriesDetail.categories
        ? createCrumbsFromCategoryTree(
            props.data.seriesDetail.categories,
            props.data.seriesDetail.title
          )
        : [],
    []
  )

  React.useEffect(() => {
    dy.reportPageVisit({
      type: 'OTHER',
      data: [],
      location: window.location.href,
      locale: config.i18n.locale.replace('-', '_')
    })
    mount(props.data.seriesDetail)
  }, [])

  return (
    <Layout
      breadcrumbs={crumbs}
      pageContext={{
        type: 'Other',
        ready: true,
        path: props.pageContext.slug
      }}
    >
      <Seo
        location={props.location}
        canonicalUrl={`${config.baseUrl}/${config.locale}/series/${props.pageContext.slug}/`}
        title={props.data.seriesDetail.title}
        description={props.data.seriesDetail.description}
        type="website"
        hrefLang={props.data.seriesDetail.hrefLang}
      />
      <Wrapper data-cy-ctx="templates/Series">
        <Head container={props.data.seriesDetail} />
        <Listing container={props.data.seriesDetail} />
      </Wrapper>
    </Layout>
  )
})

export const query = graphql`
  query Series($slug: String!) {
    seriesDetail: series(slug: { eq: $slug }) {
      title
      description
      brand
      images
      categories
      attributes
      objectID
      variantFilters
      hrefLang {
        url
        hrefLang
      }
    }
  }
`

const Wrapper = styled(Container)`
  min-height: 100vh;
  > .Listing {
    margin-top: ${theme.spacing('ml')};

    @media (min-width: ${theme.ms.MD}px) {
      margin-top: ${theme.spacing('l')};
    }
  }
`
